<template>
    <div class="setting_list__item">
        <div class="setting_list__item_text">
            {{ __t(settingName) }}
        </div>
        <div class="setting_list__item_switch">
            <switch_block
                :key="'switch_block_'"
                :switchStatus="switchStatus"
                @click_switch="clickSwitch"
            />
        </div>
    </div>
</template>

<script>

import switch_block from "../rest/SwitchBlock.vue";
export default {
    name: "rest_list_item",
    props: {
        settingItem: {
            type: Object,
            required: true,
        },
    },
    emits: ['click_switch_item'],
    components: {switch_block},
    data() {
        return {
        }
    },
    methods: {
        clickSwitch(switchStatus) {
            this.$emit('click_switch_item', this.settingItem, switchStatus)
        },
    },
    computed: {
        settingName() {
            return this.settingItem.name;
        },
        switchStatus() {
            return this.settingItem.state;
        }
    }
}
</script>
